import angular from 'angular';
import _ from 'lodash';

import {Directive, Module} from 'app/decorators';


@Module({
    name: "app.directives.ncyBreadcrumbTitle",
})
@Directive('ncy-breadcrumb-title', function($interpolate, $breadcrumb, $rootScope) {
    "ngInject";

    return {
        restrict: 'A',
        scope: {},
        template: '{{ncyTitle}}',
            compile: function() {
                let separator = ' · ';
                let siteTitle = 'Blend 2';

                return {
                    post: function postLink(scope, element) {
                        let labelWatchers = [];

                        // ncyBreadcrumb core functions
                        let getExpression = function(interpolationFunction) {
                            if(interpolationFunction.expressions) {
                                return interpolationFunction.expressions;
                            } else {
                                let expressions = [];
                                angular.forEach(interpolationFunction.parts, function(part) {
                                    if(angular.isFunction(part)) {
                                        expressions.push(part.exp);
                                    }
                                });
                                return expressions;
                            }
                        };
                        let registerWatchersText = function(
                            labelWatcherArray, interpolationFunction, viewScope
                        ) {
                            angular.forEach(
                                getExpression(interpolationFunction),
                                function(expression) {
                                    let watcher = viewScope.$watch(expression, function(
                                        newValue, oldValue
                                    ) {
                                        if (newValue !== oldValue) {
                                            renderLabel();
                                        }
                                    });
                                    labelWatcherArray.push(watcher);
                                }
                            );
                        };
                        let deregisterWatchers = function(labelWatcherArray) {
                            angular.forEach(labelWatcherArray, function(deregisterWatch) {
                                deregisterWatch();
                            });
                            labelWatcherArray = [];
                        };
                        // -----------

                        let renderLabel = function() {
                            deregisterWatchers(labelWatchers);
                            let viewScope = $breadcrumb.$getLastViewScope();
                            let steps = $breadcrumb.getStatesChain();
                            let combinedLabels = [];
                            let ncyTitle = siteTitle;
                            _.each(steps, function (step) {
                                if (step.ncyBreadcrumb &&  step.ncyBreadcrumb.skipStateForTitle){
                                    return;
                                }
                                if (step.ncyBreadcrumb && step.ncyBreadcrumb.label) {
                                    let label = step.ncyBreadcrumb.label;
                                    if (step.ncyBreadcrumb && step.ncyBreadcrumb.siteTitle) {
                                        label = step.ncyBreadcrumb.siteTitle;
                                    }

                                    let parseLabel = $interpolate(label);
                                    combinedLabels.push({
                                        name: step.name,
                                        label: parseLabel(viewScope)
                                    });
                                    // Watcher for further viewScope updates
                                    registerWatchersText(labelWatchers, parseLabel, viewScope);
                                } else {
                                    combinedLabels.push({
                                        name: step.name,
                                        label: step.name
                                    });
                                }
                            });
                            combinedLabels = _.reverse(combinedLabels);
                            if (combinedLabels.length > 0) {
                                let title = _.map(combinedLabels, (obj) => obj.label).join(separator);
                                ncyTitle = `${title} - ${ncyTitle}`;
                            }

                            scope.ncyTitle = ncyTitle;
                        };

                        $rootScope.$on('$viewContentLoaded', function () {
                            renderLabel();
                        });

                        // View(s) may be already loaded while the directive's linking
                        renderLabel();

                        scope.$on('$onDestroy', function () {
                            element.remove();
                        })
                    }
                };

            }
        };
})
export default class D {}



// WEBPACK FOOTER //
// ./src/app/directives/ncybreadcrumb.title.js